export default [
    {
        name: 'Buses',
        path: '/buses',
        text: 'Buses',
        component: 'bus/Management',
        isActive: true,
    },
    {
        name: 'Drivers',
        path: '/drivers',
        text: 'Choferes',
        component: 'driver/Management',
        divider: true,
        isActive: true,
    },
    {
        name: 'Location',
        path: '/locations',
        text: 'Ubicaciones',
        component: 'location/Management',
        isActive: true,
    },
    {
        name: 'Journey',
        path: '/journeys',
        text: 'Trayectos',
        component: 'journey/Management',
        divider: true,
        isActive: true,
    },
    {
        name: 'Passenger',
        path: '/passengers',
        text: 'Clientes',
        component: 'passenger/Management',
        divider: true,
        isActive: true,
    },
    {
        name: 'Seat',
        path: '/seats',
        text: 'Asientos',
        component: 'seat/Management',
        isActive: true,
    },
    {
        name: 'JourneyDriver',
        path: '/journeys_drivers',
        text: 'Viajes',
        component: 'journey_driver/Management',
        divider: true,
        isActive: true,
    },
    {
        name: 'Ticket',
        path: '/tickets',
        text: 'Tickets',
        component: 'ticket/Management',
        isActive: true,
    },
    {
        name: 'TicketCreate',
        path: '/ticket_search',
        text: 'Buscar viajes disponibles',
        component: 'ticket/Search',
        isActive: true,
    },
    {
        name: 'JourneysAvailable',
        path: '/journeys_available',
        text: 'Viajes disponibles',
        component: 'ticket/ListAvailable',
        isActive: true,
        hiddenInTheSidebar: true,
    },
]